import Mutations from '../../odata/mutations';

export default { ...new Mutations('jobListingCandidateComment'), ...new Mutations('jobListingCandidateComments') };
